import { useQuery } from "@tanstack/react-query";
import type { UseQueryResult } from "@tanstack/react-query";
import type { PublicSettings } from "@spare-cart/contracts/settings";
import { apiClient } from "@core/api";
import { settingsKeys } from "./settingsKeys";

const PUBLIC_SETTINGS_STALE_MS = 5 * 60 * 1000;

export const usePublicSettings = (): UseQueryResult<PublicSettings> =>
  useQuery({
    queryKey: settingsKeys.public(),
    queryFn: () => apiClient.get<PublicSettings>("/settings/public"),
    staleTime: PUBLIC_SETTINGS_STALE_MS,
  });
